module.exports = __webpack_public_path__ + "img/logo_digtal.209633e6.svg";